import { render, staticRenderFns } from "./Продажы по группам.vue?vue&type=template&id=58e6287e&scoped=true"
import script from "./Продажы по группам.vue?vue&type=script&lang=js"
export * from "./Продажы по группам.vue?vue&type=script&lang=js"
import style0 from "./Продажы по группам.vue?vue&type=style&index=0&id=58e6287e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e6287e",
  null
  
)

export default component.exports